export default {
    //我的帖子
    getMypost (params) {
        return new Promise((resolve, reject) => {
            axios.get('/api/bbs/my-cards', {
                params:params
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
}